import { CronofyDatePickerEvent } from "@/types/scheduling/cronofy";

/**
 * Check if we're currently in the second bite flow
 */
export function isSecondBiteFlow(): boolean {
    const currentRoute = window.route().current();
    return currentRoute?.startsWith("second-bite") ?? false;
}

/**
 * Create a callback function for second bite scheduling
 * @param onSecondBiteSelect - Function to call when a slot is selected in second bite context
 * @returns Callback function for DateTimePickerWrapper
 */
export function createSecondBiteSchedulingCallback(
    onSecondBiteSelect?: () => void,
) {
    return async (e: CronofyDatePickerEvent) => {
        if (
            e.notification.type === "slot_selected" &&
            isSecondBiteFlow() &&
            onSecondBiteSelect
        ) {
            onSecondBiteSelect();
        }
    };
}

/**
 * Determine if selection should be disabled based on context
 * @param disableSelection - Override to force disable selection
 * @returns Whether selection should be disabled
 */
export function shouldDisableSelection(disableSelection?: boolean): boolean {
    // If explicitly disabled, respect that
    if (disableSelection === true) {
        return true;
    }

    // If in second bite flow, enable selection
    if (isSecondBiteFlow()) {
        return false;
    }

    // Default behavior: disable selection for view-only contexts
    return true;
}
